/*
*
* File JS componente Block Col2
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-col2.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

function initCounter(counter){

    let a = 0;
    const counterValues = document.querySelectorAll('.counter-value');
    const oTop = counter.offsetTop - window.innerHeight;
    
    function startCounters() {
        counterValues.forEach(function(element) {
            const countTo = parseInt(element.getAttribute('data-count'), 10);
            let currentCount = parseInt(element.textContent, 10);
    
            const increment = countTo / 150; // Incremento per millisecond
    
            const animationInterval = setInterval(function() {
                if (currentCount < countTo) {
                    currentCount += increment;
                    element.textContent = Math.floor(currentCount);
                } else {
                    element.textContent = countTo;
                    clearInterval(animationInterval);
                }
            }, 10); // Durata dell'animazione ridotta 
        });
        a = 1;
    }
    
    function checkScroll() {
        if (a === 0 && window.scrollY > oTop) {
            startCounters();
        }
    }
    
    window.addEventListener('scroll', checkScroll);
    document.addEventListener('DOMContentLoaded', checkScroll);
    
}

const blockCol2 = () => {
    const counter = document.querySelector('#counter');

    if(counter){
        initCounter(counter);
    }

}



export default blockCol2;

//--------------------------------------------------------------------//